import { SuccessStatus } from 'sham-components/shared/success-status';
import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-register-success',
  standalone: true,
  imports: [
    CommonModule,
    SuccessStatus,
    TranslateModule
  ],
  templateUrl: './register-success.html',
  styleUrl: './register-success.css',
})
export class RegisterSuccessPage {

  router = inject(Router);

  navigateToHome() {
    this.router.navigate(['/']);
  }
}